var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("goodsSku.package.BasicInformation")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              [
                _vm.isEdit || _vm.isAdd
                  ? _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ])
                  : _vm._e(),
                _vm.isEdit || _vm.isAdd
                  ? _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleConfirm(false)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    )
                  : _vm._e(),
              ],
              _vm.isView
                ? [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("backText")))]
                    ),
                    !_vm.$store.getters.cusId
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.showLog },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseApplyDetail.operationLog"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: {
            model: _vm.goodsData,
            rules: _vm.rules,
            "label-width": "230px",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseOrder2.form.skuName"),
                        prop: "skuName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.isView,
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t(
                            "BusinessPurchaseOrder2.form.skuName"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.skuName,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "skuName", $$v)
                          },
                          expression: "goodsData.skuName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU", prop: "skuCode" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.isView || _vm.isEdit,
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.skuCode2,
                          callback: function ($$v) {
                            _vm.skuCode2 = $$v
                          },
                          expression: "skuCode2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "BjDivider",
                [
                  _vm._v(
                    _vm._s(_vm.$t("goodsSku.package.packageProductMsg")) + " "
                  ),
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isView },
                        on: { click: _vm.onDelete },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("goodsSku.package.delete")) + "SKU"
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isView },
                        on: { click: _vm.onAddSkuDetail },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")) + "SKU")]
                    ),
                  ],
                ],
                2
              ),
              _c(
                "el-table",
                {
                  ref: "storeTable",
                  attrs: {
                    data: _vm.goodsData.skuDetailList,
                    stripe: "",
                    border: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                  },
                  on: { "selection-change": _vm.onSelections },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      type: "index",
                      label: _vm.$t("table.countText"),
                      width: "65",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "itemId",
                      type: "selection",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "standardSkuCode",
                      label: "SKU",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "skuName",
                      label: _vm.$t("BusinessPurchaseOrder2.form.skuName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "num",
                      label: _vm.$t("billingPage.quantity"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("BjInput", {
                              attrs: {
                                oninput: "value=value.replace(/[^\\d]/g,'')",
                                disabled: _vm.isView,
                                maxlength: _vm.MAX_LENGTH.NORMAL,
                                placeholder: _vm.$t("inputText"),
                                clearable: "",
                              },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action",
                      label: _vm.$t("operationText"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", disabled: _vm.isView },
                                on: {
                                  click: function ($event) {
                                    return _vm.goodsData.skuDetailList.splice(
                                      scope.$index,
                                      1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "skuDialogList",
        attrs: { config: _vm.$BjDialogListConfig.skuDefault(), multiple: "" },
        on: { confirm: _vm.onConfirmSkuDialogList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }